import { Facebook } from "lucide-react";

const FacebookButton = () => {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      {/* TikTok Button */}
      <a
        href="https://www.tiktok.com/@cglanceywindows/photo/7534480014209846550?image_index=1"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-tiktok-btn"
        className="w-14 h-14 bg-[#000000] text-white rounded-full flex items-center justify-center shadow-lg hover:bg-[#1A1A1A] hover:scale-110 transition-all duration-300 border border-[#333]"
        aria-label="Follow us on TikTok"
      >
        <svg className="w-7 h-7" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
        </svg>
      </a>
      
      {/* Facebook Button */}
      <a
        href="https://www.facebook.com/CGlanceyJoinersGlazing/?locale=en_GB"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-facebook-btn"
        className="w-14 h-14 bg-[#1877F2] text-white rounded-full flex items-center justify-center shadow-lg hover:bg-[#166FE5] hover:scale-110 transition-all duration-300"
        aria-label="Follow us on Facebook"
      >
        <Facebook className="w-7 h-7 fill-white" />
      </a>
    </div>
  );
};

export default FacebookButton;
